export const PLATFORM_CUSTOM = 'CUSTOM'
export const PLATFORM_AWS = 'AWS'
export const PLATFORM_AZURE = 'AZURE'
